module.exports={listExample:["one","two","three"]};